var JCCenter = function (src) {
    var self = this;
    src = src || {};
    self.CenterId = src.CenterId || 0;
    self.RSAPartner = src.RSAPartner || '';
    self.DeputyArea = src.DeputyArea || '';
    self.JCCC = src.JCCC || '';
    self.NationalForestGrasslands = src.NationalForestGrasslands || '';
    self.Region = src.Region || '';
    self.State = src.State || '';
    self.JCCCLinks = src.JCCCLinks || ''; 
    self.Active = src.Active || 1;
    self.Deleted = src.Deleted || 0;
    self.Creator = src.Creator || '';
    self.LastModifiedBy = src.LastModifiedBy || '';
}
angular.module('jcsfApp').value('JCCenter', JCCenter);